import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faEllipsisVertical, faFilePen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

import styles from './chronicConditionDropdown.module.css'
import DropdownMenu from './dropdownMenu';

const ChronicConditionDropdown = ({ title, content, bodyMaxHeight, onEditClick, onDeleteClick }) => {
    const [isOpen, setIsOpen] = useState(false);

    const options = [
        { name: "Edit", icon: faFilePen, onClick: (event) => onEditClick(event) },
        { name: "Delete", icon: faTrashCan, onClick: (event) => onDeleteClick(event) }
    ];

    return (
        <div
            className={`${styles.collapsable_comp} ${isOpen ? "" : styles.close}`}
        >
            <div className={`${styles.comp_header}`} onClick={() => setIsOpen(!isOpen)}>
                <div className={styles.comp_heading_wrapper}>
                    <FontAwesomeIcon icon={faChevronDown} className={styles.drop_icon} />
                    <p className={styles.comp_heading}>{title}</p>
                </div>

                <DropdownMenu options={options} triggerIcon={faEllipsisVertical} />

            </div>

            <div className={styles.comp_body} style={{ maxHeight: isOpen ? bodyMaxHeight : '' }}>
                {content}
            </div>
        </div>
    )
}

export default ChronicConditionDropdown